export const billingToolLoadError = 'Unable to load Billing Tool';
